import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'; 
import { FormSequenceDocument } from './components/formSequenceDocument';
import { Detalhes } from '@/types/DetailNF' 
import { Impediment } from './components/impediment'; 

interface PropsDetail {
    detail: Detalhes
    nf: string
}

export function Actions( {detail, nf} : PropsDetail) {
   
 
  return (  
    <div className="grid gap-6 md:grid-cols-2 h-full">
        <Card>
            <CardHeader className="pb-2">
                <CardTitle className="flex items-center text-lg"> 
                    Impeditivo
                </CardTitle> 
            </CardHeader>
            <CardContent>
                <Impediment impediment={detail.SK_IMPEDITIVO} nf={nf}/>
            </CardContent>
        </Card>

        <Card >
            <CardHeader className="pb-2">
                <CardTitle className="flex items-center text-lg"> 
                    Documento de Sequência
                </CardTitle>
            </CardHeader>
            <CardContent>
                <FormSequenceDocument document={detail.DD_DOC_SEQUENCIA} nf={nf} serie={detail.DD_SERIE_SEQUENCIA}/>
            </CardContent>
        </Card> 
    </div>
    
  );
}